import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { BuildingType } from "../../data";

@Component({
    selector: "[app-wall]",
    templateUrl: "./wall.component.html",
    styleUrls: ["./wall.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WallComponent {
  height = input<number>();
  width = input<number>();
  type = input<BuildingType>();

  leftWallPoints = computed(() => this.getWallPoints(this.type(), 'left'));
  rightWallPoints = computed(() => this.getWallPoints(this.type(), 'right'));

  /**
   * General method to get wall points for both left and right walls.
   * @param type - The building type
   * @param wallSide - The side of the wall (left or right)
   * @returns SVG path data
   */
  private getWallPoints(type: BuildingType, wallSide: 'left' | 'right'): string {
    const baseHeight = this.height();
    
    const wallData = {
      [BuildingType.Library]: {
        left: `M21 ${baseHeight + 15} L21 101 L152 176 L152 ${baseHeight + 90} Z`,
        right: `M152 176 L329 73 L329 ${baseHeight - 5} L152 ${baseHeight + 90} Z`
      },
      [BuildingType.Dummy]: {
        left: `M0 184.572L97.0854 242.917L97.3795 117.215L0 58.7021V184.572Z`,
        right: `M97.0854 242.917L195.247 184.7V58.7021L97.3795 117.215L97.0854 242.917Z`
      },
      [BuildingType.Management]: {
        left: `M1 ${baseHeight + 15} L3 85 L96 144 L96 ${baseHeight + 80} Z`,
        right: `M96 144 L231 60 L231 ${baseHeight - 5} L96 ${baseHeight + 80} Z`
      },
      [BuildingType.Tracker]: {
        left: `M0 91 L114 158 L114 ${baseHeight + 18} L0 ${baseHeight - 48} Z`,
        right: `M114 158 L188 114 L188 ${baseHeight - 26} L114 ${baseHeight + 18} Z`
      },
      [BuildingType.Monitoring_Reporting]: {
        left: `M0 101 L178 208 L178 ${baseHeight + 37} L0 ${baseHeight - 68} Z`,
        right: `M178 208 L299 135 L299 ${baseHeight - 38} L178 ${baseHeight + 37} Z`
      },
      [BuildingType.SpaceConfig]: {
        left: `M0 101 L137 168 L137 ${baseHeight + 37} L0 ${baseHeight - 30} Z`,
        right: `M137 168 L274 101 L274 ${baseHeight - 30} L137 ${baseHeight + 37} Z`
      },
      [BuildingType.Catalog]: {
        left: `M0 101 L187 211 L187 ${baseHeight + 80} L0 ${baseHeight - 30} Z`,
        right: `M187 211 L375 101 L375 ${baseHeight - 30} L187 ${baseHeight + 80} Z`
      },
      [BuildingType.Marketplace]: {
        left: `M1 122 L108 186 L108 ${baseHeight + 80} L0 ${baseHeight + 15} Z`,
        right: `M108 186 L310 66 L310 ${baseHeight - 40} L108 ${baseHeight + 80} Z`
      },
      [BuildingType.Warehouse]: {
        left: `M0.5 70 L115 139 L115 ${baseHeight + 80} L0.5 ${baseHeight + 15} V70 Z`,
        right: `M231 ${baseHeight + 15} L116 ${baseHeight + 80} L116 139 L231 70 V${baseHeight + 15} Z`
      }
    };

    return wallData[type] ? wallData[type][wallSide] : '';
  }

  trackByIndex(index: number) {
    return index;
  }
}
